import React from "react";
import { useLocation } from "react-router-dom";
import "./index.scss";
import FormHeader from "./Header";

const CantQuote = () => {
  const location = useLocation();
  const notice = location.state?.message;

  return (
    <>
      <FormHeader />
      <div className="error-container">
        {notice ? (
          <p>
            <strong>{notice}</strong>
          </p>
        ) : (
          <>
            <p>Thank you!</p>
            <p>
              We've received your submission and appreciate you reaching out.{" "}
              <strong>
                A member of our team will review your information and contact you
                shortly to discuss your matter further.
              </strong>
            </p>
            <div className="note">
              <p>
                <strong>PLEASE NOTE:</strong> Submitting this form does not create
                an attorney–client relationship. Representation begins only after a
                written agreement by both parties. If you need immediate assistance,
                call us at 877-227-3872.
              </p>
            </div>
          </>
        )}

        <a href="tel:+18772272872" className="call-button" title="Call Now">
          📞
        </a>
      </div>
    </>
  );
};

export default CantQuote;
